import type { LocaleCode } from '@event/i18n';
import type { LocalizedText } from '../api/types';

/**
 * Pick the best-matching string from a localized jsonb payload. Falls
 * back to Czech (our base locale) and then to the first value present
 * so the UI never crashes on a partial translation while the missing
 * key shows up loudly enough to be noticed in review.
 */
export function pickLocalized(
  text: LocalizedText | undefined,
  locale: LocaleCode,
): string {
  if (!text) return '';
  if (text[locale]) return text[locale];
  if (text.cs) return text.cs;
  if (text.en) return text.en;
  const first = Object.values(text)[0];
  return typeof first === 'string' ? first : '';
}
